import { FeatureFlagsEnum } from '../types/working-model';

// add toggle-able flags to this map
const featureFlagKeyMap: Record<string, FeatureFlagsEnum> = {
	'Digit2': FeatureFlagsEnum.metrics_api,
	'Digit3': FeatureFlagsEnum.recording_requires_jwt,
	'Digit4': FeatureFlagsEnum.integrations_confirmation_urls,
	'Digit6': FeatureFlagsEnum.custom_mapping,
	'Digit8': FeatureFlagsEnum.magic_links,
	'KeyS': FeatureFlagsEnum.test_oidc_auth,
	'KeyL': FeatureFlagsEnum.admin_email_verification,
	'KeyF': FeatureFlagsEnum.all_recording_download_requests_fail,
	'KeyA': FeatureFlagsEnum.content_speakers,
	'KeyN': FeatureFlagsEnum.navbar_v2,
	'KeyW': FeatureFlagsEnum.session_details_v2,
	'KeyE': FeatureFlagsEnum.translations_v3,
	'KeyV': FeatureFlagsEnum.video_v2,
	'KeyM': FeatureFlagsEnum.google_meet_phase_1,
	'KeyI': FeatureFlagsEnum.integrations_ui_q3_2023,
	'KeyU': FeatureFlagsEnum.audience_list_ui_q3_2023,
	'KeyR': FeatureFlagsEnum.registration_v2_q1_2024,
	'KeyG': FeatureFlagsEnum.go_to_greenroom_for_all_broadcast_types,
	'KeyH': FeatureFlagsEnum.recording_requires_jwt,
	'KeyP': FeatureFlagsEnum.color_palettes,
	// Important: Do not use the KeyT because on windows machines "alt + shift + t" is a reserved hotkey for the back arrow
};

export default featureFlagKeyMap;
